import { getSettings, updateSettings } from "../../api/setting";
import { log2 } from "../../utils/log2";
import _ from "lodash";
import CONFIG from "../../config/config";
import { UtilFunctions } from "../../utils/UtilFunctions";
const defaultPreferredThemeColor = "servquick";
const defaultPreferredAnimation = "No Animation";
const defaultContentOfBubbleMessage = "Do you need help?";
const defaultInputPixels = {
    xAxis: 0,
    yAxis: 0,
};
const log = log2("settings.vuex");
const setting = {
    namespaced: true,
    state: {
        allThemeColors: [
            "black",
            "gray",
            "yellow",
            "orange",
            "red",
            "green",
            "pink",
            "purple",
            "blue",
            "mango",
            "servquick",
            "custom",
        ],
        allAnimations: [
            "No Animation",
            "bounce",
            "flash",
            "pulse",
            "rubberBand",
            "shake",
            "bounceIn",
            "flip",
            "swing",
            "tada",
            "wobble",
            "jello",
        ],
        inputPixels: defaultInputPixels,
        contentOfBubbleMessage: defaultContentOfBubbleMessage,
        settings: {
            language: {},
            chatCustomizationSettings: {
                preferredThemeColor: defaultPreferredThemeColor,
                preferredAnimation: defaultPreferredAnimation,
            },
            customLoginFormEnabled: false,
            initialized: true,
            isEnabledTriggers: false,
        },
        initialized: false,
        offlineMode: false,
        prevSettings: null,
    },
    getters: {
        whatsappEnabled: (state) =>
            _.get(state.settings, "whatsapp.enabled", false) || _.get(state.settings, "whatsapp.plus.enabled", false),
        telegramBotEnabled: (state) => !!_.get(state.settings, "telegrambot.token", false),
        telegramEnabled: (state) => !!_.get(state.settings, "telegrambot.token", false),
        gpt3Enabled: (state) =>
            (_.get(state.settings, "gpt3.trial", false) && _.get(state.settings, "gpt3.trialMessageLimit", 0) > 0) ||
            !!_.get(state.settings, "gpt3.apiKey", false),
        trialMessageLimit: (state) => _.get(state.settings, "gpt3.trialMessageLimit", 0),
        shouldSelectPlan(state, payload, rootState) {
            const correctEnvironment = CONFIG.PRODUCTION || CONFIG.IS_STAGE;
            const features = rootState.site.features;
            const activeUserCount = rootState.user.activeUserCount;
            const whatsappChannels = rootState.channel.channels.filter((channel) =>
                ["whatsapp-qr", "whatsapp-v2"].includes(channel.type)
            );
            const whatsappBusinessChannels = rootState.channel.channels.filter(
                (channel) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(channel.type)
            );
            const instagramChannels = rootState.channel.channels.filter((channel) => ["instagram", "instagram-v2"].includes(channel.type));
            const messengerChannels = rootState.channel.channels.filter((channel) => channel.type === "messenger");

            const result = {
                enabled:
                    rootState.site.initializedFeatures &&
                    rootState.site.plansAvailable &&
                    state.initialized &&
                    (activeUserCount > (features.maxAgentCount || 0) ||
                        whatsappChannels.length > (features.maxWhatsappChannel || 0) ||
                        whatsappBusinessChannels.length > (features.maxBusinessWhatsappChannel || 0) ||
                        messengerChannels.length > (features.maxMessengerChannel || 0) ||
                        instagramChannels.length > (features.maxInstagramChannel || 0) ||
                        0),
                supsisPackage: activeUserCount > (features.maxAgentCount || 0),
                whatsappQr: whatsappChannels.length > (features.maxWhatsappChannel || 0),
                whatsappBusiness: whatsappBusinessChannels.length > (features.maxBusinessWhatsappChannel || 0),
                instagram: instagramChannels.length > (features.maxInstagramChannel || 0),
                messenger: messengerChannels.length > (features.maxMessengerChannel || 0),
                details: {
                    limit: {
                        currentWhatsappBusinessChannelCount: features.maxBusinessWhatsappChannel || 0,
                        currentWhatsappPlanCount: features.maxWhatsappChannel || 0,
                        currentSupsisAgentCount: features.maxAgentCount || 0,
                        messenger: features.maxMessengerChannel || 0,
                        instagram: features.maxInstagramChannel || 0,
                    },
                    current: {
                        users: activeUserCount,
                        whatsappQr: whatsappChannels.length,
                        whatsappBusinessChannels: whatsappBusinessChannels.length,
                        instagram: instagramChannels.length,
                        messenger: messengerChannels.length,
                    },
                },
            };

            console.log("shouldSelectPlan", {
                plansAvailable: rootState.site.plansAvailable,
                users: activeUserCount,
                maxAgentCount: features.maxAgentCount,
                whatsappChannels: whatsappChannels.length,
                whatsappBusinessChannels: whatsappBusinessChannels.length,
                maxWhatsappChannel: features.maxWhatsappChannel,
                maxBusinessWhatsappChannel: features.maxBusinessWhatsappChannel,
                shouldSelectPlan: result,
            });
            return result;
        },
    },
    mutations: {
        SET_SETTINGS: (state, payload) => {
            log.debug("SET_SETTINGS", payload);
            state.settings = payload;
        },
        SET_SETTINGS_INITIALIZED: (state) => {
            state.initialized = true;
        },
        SET_SETTING_VALUE: (state, payload) => {
            // prevSettings'i BURADA güncelleme, sadece ilk yüklemede ve save sonrası güncelle
            const newSettings = _.cloneDeep(state.settings);
            _.set(newSettings, payload.setting, payload.value);
            const diff = UtilFunctions.difference(newSettings, state.prevSettings);
            const isUpdated = Object.keys(diff).length > 0;
            log.debug("SET_SETTING_VALUE", { payload, diff, isUpdated });
            if (isUpdated) {
                _.set(state.settings, payload.setting, payload.value);
                return state.settings;
            }

            return state.settings;
        },
        SET_PREV_SETTINGS: (state, payload) => {
            state.prevSettings = _.cloneDeep(state.settings);
        },
        OFFLINE_MODE_UPDATED: (state, payload) => {
            //log.debug("OFFLINE_MODE_UPDATED", payload)
            state.offlineMode = payload;
        },
    },
    actions: {
        getSettings({ commit }, data) {
            return getSettings().then((response) => {
                let settings = {
                    language: {},
                };
                if (response.data.length > 0) {
                    settings = response.data[0];
                }
                if (settings.language == null) {
                    settings.language = {};
                }
                commit("SET_SETTINGS", settings);
                commit("SET_SETTINGS_INITIALIZED");
                commit("SET_PREV_SETTINGS");
                return response;
            });
        },
        updateSettings({ state, commit }, newSettings) {
            newSettings  = _.cloneDeep(newSettings);
            const prevSettings = _.cloneDeep(state.prevSettings);
            const diff = UtilFunctions.difference(newSettings, prevSettings);
            const isUpdated = Object.keys(diff).length > 0;

            log("updateSettings called", { newSettings, prevSettings,diff, isUpdated  });
            return updateSettings(newSettings, prevSettings).then((response) => {
                // Save başarılı olduktan sonra prevSettings'i güncelle
                commit("SET_PREV_SETTINGS");
                return response;
            });
        },

        setSettingValue({ commit, state }, payload) {
            payload = Array.isArray(payload) ? payload : [payload];
            payload.forEach((x) => {
                commit("SET_SETTING_VALUE", x);
            });
            return Promise.resolve(state.settings);
        },
        setSettings({ commit }, payload) {
            commit("SET_SETTINGS", payload.settings);
        },
        offlineModeUpdated({ commit }, payload) {
            commit("OFFLINE_MODE_UPDATED", payload.offlineMode);
        },
    },
};

export default setting;
